import * as React from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../app/hooks";
import bestAvailableModelSlice from "../data/slices/best-available-model-slice";

export const ConfirmationModal: React.FC = () => {
    const bestAvailableText = useAppSelector((state) => state.bestAvailableText);
    const bestAvailableModel = useAppSelector((state) => state.bestAvailableModel);
    const dispatch = useDispatch();

    const updateShowModal = (showModal: boolean) => {
        dispatch(bestAvailableModelSlice.actions.updateShowWheelchairModal(showModal));
    }

    return (
        <div className="modal-wrapper">
            <div id="wheelchairSeatingModal" className="modal-container">
                <div role="dialog" aria-labelledby="wheelchairSeating" className="modal-dialog">
                    <div className="modal-outer">
                        <div className="modal-inner">
                            <div className="stack-lg">
                                <div>
                                    <h1 className="h3-style">{bestAvailableText.modalHeader}</h1>
                                </div>
                                {
                                    bestAvailableText.wheelchairModalDescription &&
                                    <div className="rich-text" dangerouslySetInnerHTML={{ __html: bestAvailableText.wheelchairModalDescription }} />
                                }
                                <div>
                                    <button type="button" className="modal-close btn-secondary" onClick={() => updateShowModal(false)}>
                                        {bestAvailableText.modalCancelButtonText}
                                    </button>
                                    <a href={bestAvailableModel.smartSeatUrl} className="btn">
                                        {bestAvailableText.modalProceedButtonText}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
